export default __webpack_public_path__ + "static/media/communityMobile.29515ea3.png";